import { j as e } from "./jsx-runtime-944c88e2.js";
import { Icon as S, ChevronUpIcon as m, ArrowBackIcon as F, ChevronDownIcon as I } from "@chakra-ui/icons";
import { useDisclosure as k, Box as s, Text as l, Button as x, Menu as D, MenuButton as M, MenuList as $, Flex as H, RadioGroup as O, MenuItem as B, Radio as K, Drawer as Z, DrawerOverlay as T, DrawerContent as V, DrawerHeader as z, DrawerBody as W, DrawerFooter as E } from "@chakra-ui/react";
import L, { useState as X, useEffect as _ } from "react";
import { u as q, T as o } from "./eMyAsurionProvider-5bc36307.js";
import "@tanstack/react-query";
import "./useAccount-a03adfa5.js";
import "./myasurion-shared.mixpanel.es.js";
import "./features-979fdcf7.js";
import "./providers-29a9425c.js";
import "react-router-dom";
import "./cleave-react-node-c4a374e5.js";
import "./lodash-9598aa3c.js";
import "@react-oauth/google";
import "./domains-7d097fe4.js";
import "./myasurion-shared.carrier.es.js";
import "framer-motion";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "@emotion/react";
import "./ProfileIcon-8cf21b72.js";
import "./myasurion-shared.profile.es.js";
import "react-dom";
import "mixpanel-browser";
import "@emotion/styled";
const A = ({ fillColor: i = "#09411D", ...a }) => /* @__PURE__ */ e.jsx(
  S,
  {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a,
    children: /* @__PURE__ */ e.jsx("g", { id: "Icon / Settings", children: /* @__PURE__ */ e.jsxs("g", { id: "Vector", children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.25 8.99902C20.904 8.99902 22.25 7.65302 22.25 5.99902C22.25 4.34502 20.904 2.99902 19.25 2.99902C17.948 2.99902 16.849 3.83702 16.435 4.99902H2.25V6.99902H16.435C16.849 8.16102 17.948 8.99902 19.25 8.99902ZM19.25 4.99902C19.801 4.99902 20.25 5.44802 20.25 5.99902C20.25 6.55202 19.801 6.99902 19.25 6.99902C18.699 6.99902 18.25 6.55202 18.25 5.99902C18.25 5.44802 18.699 4.99902 19.25 4.99902Z",
          fill: i
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.25 8.99902C7.948 8.99902 6.849 9.83702 6.435 10.999H2.25V12.999H6.435C6.849 14.161 7.949 14.999 9.25 14.999C10.551 14.999 11.651 14.161 12.065 12.999H22.25V10.999H12.065C11.651 9.83702 10.552 8.99902 9.25 8.99902ZM9.25 12.999C8.699 12.999 8.25 12.552 8.25 11.999C8.25 11.448 8.699 10.999 9.25 10.999C9.801 10.999 10.25 11.448 10.25 11.999C10.25 12.552 9.801 12.999 9.25 12.999Z",
          fill: i
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.435 16.999C16.849 15.837 17.948 14.999 19.25 14.999C20.904 14.999 22.25 16.345 22.25 17.999C22.25 19.653 20.904 20.999 19.25 20.999C17.949 20.999 16.849 20.161 16.435 18.999H2.25V16.999H16.435ZM18.25 17.999C18.25 18.552 18.699 18.999 19.25 18.999C19.801 18.999 20.25 18.552 20.25 17.999C20.25 17.448 19.801 16.999 19.25 16.999C18.699 16.999 18.25 17.448 18.25 17.999Z",
          fill: i
        }
      )
    ] }) })
  }
), g9 = ({
  SortOptions: i,
  sidebarBody: a,
  getSelectedOption: j,
  backLbl: d,
  showBackBtn: f = !0,
  applyFilterCallback: G
}) => {
  const { isOpen: u, onOpen: C, onClose: h } = k(), [r, y] = X("Best selling"), g = L.useRef(null), { data: w } = q(), { theme: b } = w, { colors: t } = b, n = "SmartStock", v = (p = !1) => p ? /* @__PURE__ */ e.jsx(m, { h: "6", w: "6", color: t.primary }) : /* @__PURE__ */ e.jsx(I, { h: "6", w: "6", color: t.primary });
  return _(() => {
    j(r);
  }, [r]), /* @__PURE__ */ e.jsxs(s, { children: [
    /* @__PURE__ */ e.jsx(s, { bg: "#F0F0F5", children: /* @__PURE__ */ e.jsxs("center", { children: [
      /* @__PURE__ */ e.jsx(l, { fontSize: "24px", fontWeight: "700", pt: "36px", children: /* @__PURE__ */ e.jsx(
        o,
        {
          text: "Choose a different phone?",
          translationKey: `${n}/lblChooseDiffPhone`
        }
      ) }),
      /* @__PURE__ */ e.jsx(l, { fontWeight: "300", paddingX: "6px", children: /* @__PURE__ */ e.jsx(
        o,
        {
          text: "Other devices are available with several service request fee (SRF) based on the model and capacity",
          translationKey: `${n}/lblOtherDeviceFeeInfo`
        }
      ) }),
      /* @__PURE__ */ e.jsxs(s, { display: "flex", justifyContent: "space-evenly", pt: "16px", pb: "24px", children: [
        /* @__PURE__ */ e.jsxs(
          x,
          {
            onClick: C,
            color: t.primary,
            variant: "outline",
            paddingX: "30px",
            children: [
              /* @__PURE__ */ e.jsx(A, { h: "24px", w: "24px", fillColor: t.primary }),
              /* @__PURE__ */ e.jsx("span", { style: { paddingInline: "8px", color: t == null ? void 0 : t.accent }, children: /* @__PURE__ */ e.jsx(
                o,
                {
                  text: "Filter",
                  translationKey: `${n}/btnFilter`
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ e.jsx(D, { children: ({ isOpen: p }) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            M,
            {
              as: x,
              borderRadius: "8px",
              rightIcon: v(p),
              variant: "outline",
              color: t.primary,
              children: /* @__PURE__ */ e.jsx(
                l,
                {
                  noOfLines: 3,
                  paddingTop: "2px",
                  fontSize: "14px",
                  width: "80px",
                  color: t.accent,
                  children: /* @__PURE__ */ e.jsx(
                    o,
                    {
                      text: r,
                      translationKey: `${n}/${r}`
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ e.jsxs(
            $,
            {
              zIndex: 3,
              border: "1px solid black",
              borderRadius: "8px",
              py: "0.5rem",
              maxW: "full",
              background: "white",
              children: [
                /* @__PURE__ */ e.jsxs(
                  H,
                  {
                    justifyContent: "space-between",
                    py: "0.25rem",
                    px: "1rem",
                    borderBottom: "1px solid black",
                    children: [
                      /* @__PURE__ */ e.jsx(
                        l,
                        {
                          display: "inline-block",
                          fontWeight: "bold",
                          color: t.accent,
                          children: /* @__PURE__ */ e.jsx(
                            o,
                            {
                              text: r,
                              translationKey: `${n}/${r}`
                            }
                          )
                        }
                      ),
                      /* @__PURE__ */ e.jsx("span", { children: /* @__PURE__ */ e.jsx(m, { w: 6, h: 6 }) })
                    ]
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  O,
                  {
                    onChange: y,
                    value: r,
                    children: i.map((c, R) => /* @__PURE__ */ e.jsx(B, { children: /* @__PURE__ */ e.jsx(K, { value: c.name, children: /* @__PURE__ */ e.jsx(
                      o,
                      {
                        text: c.name,
                        translationKey: `${n}/${c.name}`
                      }
                    ) }) }, R))
                  }
                )
              ]
            }
          )
        ] }) })
      ] })
    ] }) }),
    /* @__PURE__ */ e.jsx(s, { children: /* @__PURE__ */ e.jsxs(Z, { isOpen: u, placement: "right", onClose: h, finalFocusRef: g, children: [
      /* @__PURE__ */ e.jsx(T, {}),
      /* @__PURE__ */ e.jsxs(V, { paddingTop: "4rem", children: [
        /* @__PURE__ */ e.jsx(z, { children: f && /* @__PURE__ */ e.jsx(
          x,
          {
            fontSize: "16px",
            variant: "link",
            colorScheme: "black",
            leftIcon: /* @__PURE__ */ e.jsx(F, {}),
            onClick: h,
            justifyContent: "flex-start",
            children: d && /* @__PURE__ */ e.jsx(
              o,
              {
                text: d,
                translationKey: `${n}/backLbl`
              }
            )
          }
        ) }),
        /* @__PURE__ */ e.jsx(W, { px: 0, children: a }),
        /* @__PURE__ */ e.jsx(
          E,
          {
            bg: "white",
            style: { boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.08)" }
          }
        )
      ] })
    ] }) })
  ] });
};
export {
  g9 as SmartStock
};
